import { api } from '@/utils/api';
import { InflowInfiltrationMetrics, PastOverflowMetrics } from './Dashboard';


export default class DashboardRepository {
    async getInflowInfiltrationMetrics(type: string, locationId: number, assetId: number, startDate: string, endDate: string): Promise<InflowInfiltrationMetrics> {
        const response = await api.get(`/mode?type=${type}&locationId=${locationId}&assetId=${assetId}&startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    }

    async getPastOverflowMetrics(locationId: number, startDate: string, endDate: string): Promise<PastOverflowMetrics> {
        const response = await api.get(`/mode?type=past_overflow_mode&locationId=${locationId}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`);
        return response.data;
    }
}
